import { BCPopover } from '@bimser/components';
import React from 'react';
import IProps from './entities/IDMThumbnailProps';
import Style from './assets/style.scss';
import HTTPRequest from '../../services/HTTPRequest';

const DmThumbnail = (props: IProps) => {
	const [imgSrc, setImgSrc] = React.useState(null);

	React.useEffect(() => {
		const imgUrl =
			(window as any).serviceConfig.services.dm.baseURL +
			'/DocumentManagement/Objects/Thumbnail?secretKey=' +
			encodeURIComponent(props.secretKey);

		HTTPRequest.head(imgUrl, { cache: true }).then(() => {
			fetch(imgUrl, { headers: HTTPRequest.defaultHeaders })
				.then(response => response.blob())
				.then(blobData => {
					setImgSrc(URL.createObjectURL(blobData));
				});
		});
	}, []);

	const noOpFunc = (e: React.MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();
	};

	return imgSrc ? (
		<BCPopover
			trigger="hover"
			content={
				<img
					className={Style.thumbnailPopoverContent}
					src={imgSrc}
					onMouseDown={noOpFunc}
					onClick={noOpFunc}
				/>
			}
		>
			{props.iconSize != 16 ? (
				<img
					src={imgSrc}
					className={props.className}
					onMouseDown={noOpFunc}
					onClick={noOpFunc}
					width={props.iconSize}
					height={props.iconSize}
				/>
			) : (
				<span
					onMouseDown={noOpFunc}
					onClick={noOpFunc}
				>
					{props.defaultIcon}
				</span>
			)}
		</BCPopover>
	) : (
		props.defaultIcon
	);
};

export default DmThumbnail;
